import React from 'react';
import styled from 'styled-components';
import SideMenu from 'components/SideMenu';

const Main = styled.main`
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-top: 0;
    padding-bottom: 80px;
    flex-grow: 1;
    overflow-x: hidden;

    &.fullscreen {
        padding-bottom: 20px;
        overflow-y: auto;
        height: 100vh;
        height: 100dvh;
    }

    @media screen and (max-height: 670px) {
        padding: 10px;
        padding-top: 0;
    }
`;

const MainContainer = ({ children, withBottomNavigation=true, withSideMenu = true, menuOpen = false, toggleMenu }) => {
    return (
        <>
            <Main className={withBottomNavigation ? '' : 'fullscreen'}>{children}</Main>
            {withSideMenu && <SideMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />}
        </>
    );
};

export default MainContainer;